// src/axios.js
import axios from "axios";
import store from "./store";
import router from "@/router"; 

const apiKey = "https://api.cards.edus.kz/public/";
//const apiKey = "http://192.168.31.88:8080/";
//const apiKey = "http://192.168.31.24:8080/";

const instance = axios.create({
  baseURL: apiKey, 
});

instance.interceptors.request.use(
  (config) => {
    const activeToken = store.getters.activeToken;
    if (activeToken) {
      config.headers.Authorization = `Bearer ${activeToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


instance.interceptors.response.use(
  (response) => {

    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {

      store.dispatch("logout");
      router.push("/login");
      setTimeout(reloadPage, 1000);
    }
    return Promise.reject(error);
  }
);

function reloadPage() {
  location.reload();
}


export default instance;
